/* eslint-disable react/no-unused-state */
import React, { Component } from "react";

import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CRow
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../../../../../actions/baseActions";
import { setObj } from "../../../../../../actions/noteActions";
import Breadcrumb from "../../../../../../components/Breadcrumb";
import Loading from "../../../../../../components/Loading";
import ProtectedRoute from "../../../../../../components/ProtectedRoute";
import SelectFilter from "../../../../../../components/SelectFilter";
import DataTable from "../../../../../../components/Tables/tables";
import URL from "../../../../../../config/api";
import axios from "../../../../../../config/axios";

class QuestionBankReviewList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      groupList: [],
      regionList: [],
      schoolList: [],
      statusList: [],
      groupID: props.general.active_roles.group_id ?? null,
      regionID: props.general.active_roles.region_id ?? null,
      schoolID: props.general.active_roles.school_id ?? null,
      statusID: 1, // padrão: Pendente
      showTable: false,
      questionsList: [],
      loadingTable: false,
      currentPage: 1,
      perPage: 15,
      totalItems: 0,
      totalPages: 1,
      lastParams: {}
    };
  }

  componentDidMount() {
    this.loadInitialData();
    this.restoreFiltersFromLocalStorage();
  }

  componentWillUnmount() {
    // Limpar localStorage se estiver saindo para outra página que não seja review/edit
    const currentPath = window.location.pathname;
    if (
      !currentPath.includes("/question/bank/review/list") &&
      !currentPath.includes("/question/bank/review/edit")
    ) {
      this.clearFiltersFromLocalStorage();
    }
  }

  loadInitialData = async () => {
    const { general } = this.props;

    await Promise.all([this.getGroups(), this.getStatuses()]);

    if (general.active_roles.group_id) {
      await this.getRegions(general.active_roles.group_id);
    }

    if (general.active_roles.region_id && general.active_roles.group_id) {
      await this.getSchools(
        general.active_roles.region_id,
        general.active_roles.group_id
      );
    }

    this.setState({ loading: false });
  };

  getStatuses = async () => {
    try {
      const response = await axios.get(
        `${URL.api}evaluation/question/status/list`,
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      );
      const statuses = (response.data?.data ?? []).map(s => ({
        label: s.name,
        value: s.id
      }));
      this.setState({ statusList: statuses });
    } catch {
      toastr.error("Erro", "Falha ao buscar status.");
    }
  };

  getGroups = async () => {
    try {
      const response = await axios.get(`${URL.api}access/group/list`, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      });
      const groups = response.data?.data.map(g => ({
        label: g.name,
        value: g.id
      }));
      this.setState({ groupList: groups });
    } catch {
      toastr.error("Erro", "Falha ao buscar grupos.");
    }
  };

  getRegions = async groupId => {
    if (!groupId) {
      this.setState({
        regionList: [],
        schoolList: [],
        regionID: null,
        schoolID: null
      });
      return;
    }
    try {
      const response = await axios.get(
        `${URL.api}access/region/listRegionFilter/${groupId}`,
        {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        }
      );
      const regions = response.data?.data.map(r => ({
        label: r.name,
        value: r.id
      }));
      this.setState({ regionList: regions });
    } catch {
      toastr.error("Erro", "Falha ao buscar regiões.");
    }
  };

  getSchools = async (regionId, groupId) => {
    if (!regionId) {
      this.setState({
        schoolList: [],
        schoolID: null
      });
      return;
    }
    try {
      const response = await axios.get(
        `${URL.api}access/school/listSchoolFilter/${groupId}/${regionId}`,
        {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        }
      );
      const schools = response.data?.data.map(s => ({
        label: s.name,
        value: s.id
      }));
      this.setState({ schoolList: schools });
    } catch {
      toastr.error("Erro", "Falha ao buscar escolas.");
    }
  };

  fetchQuestions = async (params, page = 1, pageSize = 15) => {
    this.setState({ loadingTable: true });

    try {
      const response = await axios.get(
        `${URL.api}evaluation/question/listByStatus`,
        {
          headers: { Authorization: `Bearer ${this.props.user.token}` },
          params: { ...params, page, page_size: pageSize }
        }
      );

      if (response.data?.success) {
        const meta = response.data.meta ?? {};
        this.setState({
          questionsList: response.data.data ?? [],
          showTable: true,
          currentPage: meta.current_page ?? page,
          totalItems: meta.total ?? 0,
          totalPages: meta.last_page ?? 1,
          perPage: meta.per_page ?? pageSize,
          lastParams: params
        });

        if ((response.data.data ?? []).length === 0) {
          toastr.info(
            "Aviso",
            "Nenhuma questão encontrada para os filtros selecionados."
          );
        }
      } else {
        toastr.error(
          "Erro",
          response.data?.error ?? "Erro ao buscar questões."
        );
      }
    } catch {
      toastr.error("Erro", "Falha ao buscar questões. Tente novamente.");
    } finally {
      this.setState({ loadingTable: false });
    }
  };

  handleFilterClick = async () => {
    const { groupID, regionID, schoolID, statusID } = this.state;
    const { general } = this.props;

    if (!groupID) {
      toastr.warning(
        "Atenção",
        "Por favor, selecione um grupo para continuar."
      );
      return;
    }

    const params = {};
    if (statusID) params.status_id = statusID;
    if (groupID) params.group_id = groupID;
    if (regionID) params.region_id = regionID;
    if (schoolID) params.school_id = schoolID;

    const roleId = general.active_roles?.role_id;
    if (roleId) params.role_id = roleId;

    await this.fetchQuestions(params, 1, this.state.perPage);
    if (this.state.questionsList.length > 0) {
      toastr.success("Sucesso", "Questões carregadas com sucesso!");
    }
  };

  handlePageChange = page => {
    this.fetchQuestions(this.state.lastParams, page, this.state.perPage);
  };

  handleSizePerPageChange = size => {
    this.setState({ perPage: size }, () => {
      this.fetchQuestions(this.state.lastParams, 1, size);
    });
  };

  handleView = row => {
    this.saveFiltersToLocalStorage();
    this.props.history.push(`/question/bank/review/edit/${row.id}`);
  };

  saveFiltersToLocalStorage = () => {
    const { groupID, regionID, schoolID, statusID, lastParams } = this.state;
    const filtersData = {
      groupID,
      regionID,
      schoolID,
      statusID,
      lastParams,
      timestamp: new Date().getTime()
    };
    localStorage.setItem(
      "questionBankReviewFilters",
      JSON.stringify(filtersData)
    );
  };

  restoreFiltersFromLocalStorage = () => {
    try {
      const savedFilters = localStorage.getItem("questionBankReviewFilters");
      if (savedFilters) {
        const filtersData = JSON.parse(savedFilters);
        // Verificar se os dados não estão muito antigos (ex: mais de 1 hora)
        const oneHour = 60 * 60 * 1000;
        if (new Date().getTime() - filtersData.timestamp < oneHour) {
          this.setState(
            prevState => ({
              groupID: filtersData.groupID ?? prevState.groupID,
              regionID: filtersData.regionID ?? prevState.regionID,
              schoolID: filtersData.schoolID ?? prevState.schoolID,
              statusID: filtersData.statusID ?? prevState.statusID
            }),
            async () => {
              // Recarregar regiões e escolas se necessário
              if (filtersData.groupID) {
                await this.getRegions(filtersData.groupID);
              }
              if (filtersData.regionID && filtersData.groupID) {
                await this.getSchools(
                  filtersData.regionID,
                  filtersData.groupID
                );
              }
              // Se havia filtros salvos, buscar automaticamente
              if (
                filtersData.lastParams &&
                Object.keys(filtersData.lastParams).length > 0
              ) {
                this.fetchQuestions(
                  filtersData.lastParams,
                  1,
                  this.state.perPage
                );
              }
            }
          );
        } else {
          // Dados antigos, limpar
          this.clearFiltersFromLocalStorage();
        }
      }
    } catch (error) {
      // Erro ao restaurar filtros do localStorage
      this.clearFiltersFromLocalStorage();
    }
  };

  clearFiltersFromLocalStorage = () => {
    localStorage.removeItem("questionBankReviewFilters");
  };

  changeQuestionStatus = async (row, statusId, statusLabel) => {
    const { general } = this.props;
    const roleId = general.active_roles?.role_id;

    try {
      const response = await axios.post(
        `${URL.api}evaluation/question/updateStatus`,
        {
          question_id: row.id,
          group_id: this.state.groupID,
          user_role: roleId,
          status_id: statusId
        },
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      );

      if (response.data?.success) {
        toastr.success(
          "Sucesso",
          `Questão ${row.id} marcada como "${statusLabel}" com sucesso.`
        );
        this.fetchQuestions(
          this.state.lastParams,
          this.state.currentPage,
          this.state.perPage
        );
      } else {
        toastr.error(
          "Erro",
          response.data?.error ?? `Falha ao atualizar status da questão.`
        );
      }
    } catch (err) {
      const msg =
        err.response?.data?.error ?? "Falha ao atualizar status da questão.";
      toastr.error("Erro", msg);
    }
  };

  handleApprove = row => {
    const publicadoStatus = this.state.statusList.find(
      s => s.label === "Publicado"
    );
    if (publicadoStatus) {
      this.changeQuestionStatus(
        row,
        publicadoStatus.value,
        publicadoStatus.label
      );
    } else {
      toastr.error("Erro", "Status 'Publicado' não encontrado.");
    }
  };

  handleCancel = row => {
    const canceladoStatus = this.state.statusList.find(
      s => s.label === "Cancelado"
    );
    if (canceladoStatus) {
      this.changeQuestionStatus(
        row,
        canceladoStatus.value,
        canceladoStatus.label
      );
    } else {
      toastr.error("Erro", "Status 'Cancelado' não encontrado.");
    }
  };

  handlePending = row => {
    const pendenteStatus = this.state.statusList.find(
      s => s.label === "Pendente"
    );
    if (pendenteStatus) {
      this.changeQuestionStatus(
        row,
        pendenteStatus.value,
        pendenteStatus.label
      );
    } else {
      toastr.error("Erro", "Status 'Pendente' não encontrado.");
    }
  };

  render() {
    const { general } = this.props;
    const {
      loading,
      loadingTable,
      groupList,
      groupID,
      regionList,
      regionID,
      schoolList,
      schoolID,
      statusList,
      statusID,
      showTable,
      questionsList,
      currentPage,
      totalItems,
      totalPages,
      perPage
    } = this.state;

    return (
      <>
        <Breadcrumb current={this.props.currentRoute} />
        <CCard>
          <CCardHeader>
            <h4 className="card-title mb-1">Banco de Questões - Revisão</h4>
            <div className="small text-muted">
              Selecione os filtros para visualizar as questões pendentes de
              revisão.
            </div>
          </CCardHeader>
          <CCardBody>
            {loading ? (
              <Loading />
            ) : (
              <CCard className="p-4">
                <CRow>
                  <CCol sm="12" md="3" className="my-2">
                    <SelectFilter
                      title="Grupo"
                      value={groupID}
                      options={groupList}
                      disabled={!!general.active_roles.group_id}
                      setFunction={id => {
                        this.setState({ groupID: id });
                        this.getRegions(id);
                      }}
                    />
                  </CCol>
                  <CCol sm="12" md="3" className="my-2">
                    <SelectFilter
                      title="Regiões"
                      value={regionID}
                      options={regionList}
                      disabled={!groupID || !!general.active_roles.region_id}
                      setFunction={id => {
                        this.setState({
                          regionID: id,
                          schoolID: null,
                          schoolList: []
                        });
                        this.getSchools(id, groupID);
                      }}
                    />
                  </CCol>
                  <CCol sm="12" md="3" className="my-2">
                    <SelectFilter
                      key={`school-${regionID}`}
                      title="Escolas"
                      value={schoolID}
                      options={schoolList}
                      disabled={!regionID || !!general.active_roles.school_id}
                      setFunction={id => {
                        this.setState({ schoolID: id });
                      }}
                    />
                  </CCol>
                  <CCol sm="12" md="3" className="my-2">
                    <SelectFilter
                      title="Status"
                      value={statusID}
                      options={statusList}
                      setFunction={id => {
                        this.setState({ statusID: id });
                      }}
                    />
                  </CCol>
                </CRow>
                <CRow className="mt-3">
                  <CCol sm="12" md="2">
                    <CButton
                      color="primary"
                      className="w-100"
                      onClick={this.handleFilterClick}
                      disabled={loadingTable}
                    >
                      {loadingTable ? (
                        <>
                          <i className="fa fa-spinner fa-spin" /> &nbsp;
                          Carregando...
                        </>
                      ) : (
                        <>
                          <i className="fa fa-filter" /> &nbsp; Filtrar
                        </>
                      )}
                    </CButton>
                  </CCol>
                </CRow>
              </CCard>
            )}

            <hr className="my-4" />

            {showTable && (
              <>
                <DataTable
                  list={questionsList}
                  title="Questões para Revisão"
                  subtitle="Visualize, aprove ou cancele as questões do banco"
                  header={[
                    { name: "id", denomination: "ID" },
                    { name: "ability_code", denomination: "Habilidade" },
                    { name: "description", denomination: "Descrição" },
                    { name: "author", denomination: "Autor" },
                    {
                      name: "status_id",
                      denomination: "Status",
                      dataFormat: cell => {
                        const found = statusList.find(s => s.value === cell);
                        return found
                          ? found.label
                          : cell == null
                          ? "Pendente"
                          : cell;
                      }
                    }
                  ]}
                  remote
                  totalItems={totalItems}
                  totalPages={totalPages}
                  currentPage={currentPage}
                  perPage={perPage}
                  onPageChange={this.handlePageChange}
                  onSizePerPageList={this.handleSizePerPageChange}
                  action
                  btnView
                  btnAccept={general.active_roles?.role_id < 6}
                  btnDelete={general.active_roles?.role_id < 6}
                  btnPending={general.active_roles?.role_id < 6}
                  viewAction={this.handleView}
                  deletebtnAction={this.handleCancel}
                  acceptAction={this.handleApprove}
                  pendingAction={this.handlePending}
                  btnViewToolTip="Visualizar questão"
                  btnDeleteToolTip="Cancelar questão"
                  btnAcceptToolTip="Liberar questão"
                  btnPendingToolTip="Marcar como Pendente"
                />
              </>
            )}
          </CCardBody>
        </CCard>
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ logout, setObj }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuestionBankReviewList);
